import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ArcService } from './arc.service'
import { UtilsService } from './utils.service'
import { Project } from './project'
import { Observable } from 'rxjs/Observable';
import { DbRecordService } from './db-record.service'
import { DbRecord } from './db-record'
import { CriterionService } from './criterion.service';
import { TagService } from './tag.service';
import { FileService } from './file.service';
import { NoteService } from './note.service';
import { UsersService } from './users.service';
import { PageService } from './page.service';
import { RTagGroupService } from './r-tag-group.service';


@Injectable()
export class ProjectService {
  projectMap = new Map<string, Project>();
  cs: CriterionService;
  tags: TagService;
  ns: NoteService;
  requestedProject: string;

  constructor(
    private router: Router,
    private arcs: ArcService,
    private utils: UtilsService,
    private fs: FileService,
    private dbrs: DbRecordService,
    private users: UsersService,
    private rts: RTagGroupService,
    private pgs: PageService
  ) {
    this.arcs.projects = this;
  }

  get data() {
    return this.utils.data;
  }

  get email() {
    return this.utils.email;
  }

  getProjectRatingTags(p: Project) {
    return this.rts.projectsMap.get(p.id);
  }

  recordIds(p: Project) {
    const ls = this.dbrs.getProjectDbRecordsList(p).map(x =>
      x.id);
    return ls;
  }

  init() {
    let obs = this.arcs.run({ fun: 'init' });
    let pid = localStorage.getItem('currentProject');

    obs.subscribe((resp) => {
      console.log('INIT', resp);
      this.users.init(resp['users']);
      resp['projects'].forEach((p) =>
        new Project(this, p['id'], p['title'], true));
      resp['collaboratingProjects'].forEach((p) =>
        new Project(this, p['id'], p['title'], false));
      resp['shortcuts'].forEach(s => {
        const p = this.projectMap.get(s['projectId']);
        if (p) {
          p.shortcut = s.shortcut;
        }
      });
      pid = this.requestedProject || pid;
      if (pid) {
        this.router.navigate(['project', pid, 'dbRecords']);
      }
    });
  }

  switchUser(project: Project, email: string) {
    let obs = this.arcs.run({
      fun: 'switchUser',
      project: project.id,
      userEmail: email
    });
    obs.subscribe((resp) => {
      if (resp['action'] === 'created') {
        project.users.add(email);
      }
      if (resp['action'] === 'deleted') {
        project.users.delete(email);
      }
    });
  }

  createCriterion(project: Project, obj: Object) {
    this.cs.new(project, obj);
  }

  createTag(project: Project, obj: Object) {
    this.tags.new(project, obj);
  }

  createNote(project: Project, obj: Object) {
    this.ns.newFromSaved(project, obj);
  }

  get(pid) {
    return this.projectMap.get(pid);
  }

  newProject() {
    let pid = this.utils.uniqueIdentifier;
    if (!pid)
      return;
    return new Project(this, pid, '');
  }

  save(p: Project): Observable<any> {
    p.isNew = false;
    let obs = this.arcs.run({
      fun: 'saveProject',
      title: p.title,
      shortcut: p.shortcut,
      id: p.id
    });
    obs.subscribe((resp) => (resp));
    return obs;
  }

  delete(p: Project): Observable<any> {
    let obs = this.arcs.run({
      fun: 'deleteProject',
      id: p.id
    });
    obs.subscribe((resp) => this.projectMap.delete(p.id));
    return obs;
  }

  get list() {
    let ls = Array.from(this.projectMap.values());
    return ls.sort((a, b) => a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1);
  }

  initProject(p: Project) {
    p.isInitialized = false;
    this.rts.isInitialized = false;
    this.pgs.currentStart = 0;
    this.pgs.lastRecords = [];


    let obs = this.arcs.run({
      fun: 'initProject',
      projectId: p.id
    });

    obs.subscribe((resp) => {
      console.log('initProject', resp);
      window['rrr'] = resp['ratings'];

      let obs2 = this.arcs.run({
        fun: 'getListOfUploadedFiles',
        project: p.shortcut
      });
      obs2.subscribe((resp2) => {
        this.fs.clear();
        resp2['files'].forEach((obj) => this.fs.newFromSaved(obj));
      });

      let linkCodes = resp['linkCodes'];
      p.linkCodes = linkCodes;
      let c = 0;
      Object.keys(linkCodes).forEach(x => {
        let i = parseInt(linkCodes[x].slice(3), 10);
        if (i > c) {
          c = i;
        }
      });
      this.dbrs.setLastLinkCode(c + 1);

      this.dbrs.getProjectRecords(p, resp['files']);
      p.initRatings(resp['ratings']);
      p.initCollaborators(resp['collaborators']);
      resp['notes'].forEach((n) =>
        this.ns.newFromSaved(p, n));
    });
    this.rts.checkRecords();
    return obs;
  }

  batchSaveRatings(
    project: Project,
    dbRecords: DbRecord[],
    ratingType: string,
    tpl: [string, string[]]
  ) {
    let obs = this.arcs.run({
      fun: 'batchSaveRatings',
      project: project.id,
      records: dbRecords.map(x => x.id),
      ratingType: ratingType,
      ratingValue: tpl
    });
    return obs;

  }

  saveRating(project: Project,
    dbRecord: DbRecord,
    ratingType: string,
    tpl: [string, Set<string>]) {


    let ratingValue = null;
    if (tpl) {
      let ls = [];
      tpl[1].forEach(x => ls.push(x));
      ratingValue = [tpl[0], ls];
    }
    let obs = this.arcs.run({
      fun: 'saveRating',
      project: project.id,
      record: dbRecord.id,
      ratingType: ratingType,
      ratingValue: ratingValue
    });
    obs.subscribe((resp) => resp);
  }

  adminRatingDelete(project: Project,
    dbRecord: DbRecord,
    ratingType: string,
    email: string) {

    let obs = this.arcs.run({
      fun: 'adminRatingDelete',
      project: project.id,
      record: dbRecord.id,
      ratingType: ratingType,
      userEmail: email
    });
    obs.subscribe((resp) => resp);
    return obs;
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/project.service.ts